import * as React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { get } from 'lodash';
import { Services } from '@configuratorware/configurator-frontendgui/App/ServiceLocator';
import { ConnectedCalculationWidgetScreen } from '@configuratorware/configurator-frontendgui/App/Screens/Configurator/CalculationWidgetScreen';
import CalculationWidgetContainer from '@configuratorware/configurator-frontendgui/App/Screens/Configurator/Containers/CalculationWidget';
import CalculationWidget from '../Components/CalculationWidget';
import CustomThemeProvider from '../ThemeProvider';

const CustomCalculationWidgetScreen = (props) => {
  const configurator = useSelector((state) => state.configurator);
  const { configuration } = configurator;
  const itemIdentifier = get(configuration, 'item.identifier', '');
  const query = new URLSearchParams(location.search);
  const selectedAmount = query.get('_quantity');
  React.useEffect(() => {
    if (selectedAmount) {
      Services.configurator.setSelectedAmount(false, Number(selectedAmount), false);
    }
  }, [itemIdentifier]);

  return (
    <ConnectedCalculationWidgetScreen
      {...props}
      ThemeProvider={CustomThemeProvider}
      renderWidget={() => (
        <CalculationWidgetContainer
          defaultDesignArea={null}
          CalculationWidgetComponent={CalculationWidget}
          toggleDesignArea={async (designAreaIdentifier, active) => {
            try {
              await Services.designData.addSampleImageForDesignAreas([designAreaIdentifier], active);
            } catch (error) {
              console.error('Failed to toggle design area:', error);
            }
          }}
        ></CalculationWidgetContainer>
      )}
    />
  );
};

export default CustomCalculationWidgetScreen;

CustomCalculationWidgetScreen.propTypes = {
  renderWidget: PropTypes.func,
};
